import React from 'react';

const MembershipConsiderations = () => {

    const h2Style = {
        color: "#012F47",
        fontWeight: "bold",
        fontSize: "28px"
    }

    const h3Style = {
        color: "#012F47",
        fontWeight: "bold",
        fontSize: "24px"
    }

  return (
            <div className="flex flex-col justify-start text-left mt-4 px-4">
                <div className="w-fit">
                    <h2 className="mt-2 border-b-2 border-[#012F47] pb-1 mb-4 inline-block" style={h2Style}>Membership for Livermore Lodge 219</h2>
                </div>
                <h3 style={h3Style}>Why you should consider joining the Livermore Lodge 219:</h3>
                <ul className="mt-4 list-disc list-inside space-y-2">
                    <li className="mb-4 text-md text-[#012F47] px-6 md:px-16">The lodge is a space to make friends in your community and connect with individuals you may not have an opportunity to meet otherwise.</li>
                    <li className="mb-4 text-md text-[#012F47] px-6 md:px-16">Being a member of the lodge provides you an opportunity to support Livermore and the Tri-Valley community.</li>
                </ul>
                    <p className="mt-8 mb-4 text-md text-[#012F47] px-2 md:px-12">
                        The Livermore Lodge supports its members with seasonal dinners and events. The  
                        Lodge also supports our community with donations, fundraisers, food drives and
                        the lodge building is available to our community as a space to hold events and activities.
                    </p>
                 <h3 className="mt-4" style={h3Style}>How to get started with your membership:</h3>
                <ul className="mt-4 mb-4 list-disc list-inside space-y-2">
                    <li className="mb-4 text-md text-[#012F47] px-6 md:px-16">The first step to becoming a member is to find a sponsor to submit your application to the lodge. </li>
                    <li className="mb-4 text-md text-[#012F47] px-6 md:px-16"> If you don't know a member of the lodge and need a sponsor, please email{" "}   
                    <a href="mailto:membership@iooflivermore219.org" className="text-blue-500 hover:underline">membership@iooflivermore219.org</a>, or call us at (925) 292-1766.
                    </li>
                </ul>
                <h3 style={h3Style}>Basic Requirements to Become a Member:</h3>
                <ul className="mt-4 mb-4 list-disc list-inside space-y-2">
                    <li className="text-md text-[#012F47] px-6 md:px-16">Be 16 years or older.</li>
                    <li className="mb-4 text-md text-[#012F47] px-6 md:px-16">A person of good character, loyal to their country and believes in a Supreme Being.</li>
                    <li className="mb-4 text-md text-[#012F47] px-6 md:px-16">We strictly do not debate or interfere with eachother's religious or political beliefs.</li>
                    <li className="mb-4 text-md text-[#012F47] px-6 md:px-16">Participate in an initiation ceremony.</li>
                    <li className="mb-4 text-md text-[#012F47] px-6 md:px-16">More details will be shared with you through your sponsor and other lodge members.</li>
                </ul>
            </div>
  )
}

export default MembershipConsiderations;